import React, { ReactNode } from "react";
import { Modal, ModalBody } from "reactstrap";
import { RedWarningIcon, Warning } from "../../../assets/images";
import Checkbox from "../Checkbox";

type AppProps = {
  isOpen: boolean;
  toggle?: () => void;
  title?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onPressConfirm?: () => void;
  checkBox?: boolean;
  handleCheckBox?: boolean | (() => void);
  actionMessage?: string | ReactNode;
  actionShow?: boolean;
};

const CommfirmationWithActionModal = ({
  isOpen,
  toggle,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  onPressConfirm,
  checkBox,
  handleCheckBox,
  actionMessage,
  actionShow
}: AppProps) => {
  return (
    <>
      <Modal
        centered
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        size="sm"
        style={{ minWidth: "450px" }}
      >
        <ModalBody className="p-4">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img
              style={{ width: "85px" }}
              src={RedWarningIcon}
              alt="Warning sign"
            />
            <h3 className="mt-2 mb-3">{title}</h3>
            <h4 className="text-center">{message}</h4>
          </div>
          {typeof handleCheckBox === "function" && actionShow ? (
            <div className="d-flex justify-content-center align-items-center mt-3">
              <span className="mt-1">
                <Checkbox checked={checkBox} onPress={handleCheckBox} />
              </span>
              <span className="ml-2" style={{ fontSize: "16px" }}>
                Is this GSTR Report NIL ?
              </span>
            </div>
          ) : (
            <div className="mt-3 text-center">
              <span>{actionMessage}</span>
            </div>
          )}

          <div className="mt-3">
            <button
              className="btn btn-primary mr-5 w-100 mt-2"
              onClick={onPressConfirm}
            >
              {confirmButtonText ?? "Delete"}
            </button>
          </div>
          <div>
            <button
              className="btn btn-outline-dark w-100 mt-2"
              onClick={toggle}
            >
              {cancelButtonText ?? "Cancel"}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CommfirmationWithActionModal;
